import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/opt/homebrew/lib/node_modules/workbox-cli/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.skipWaiting();




/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "js/bootstrap.js",
    "revision": "3ae5cb7b92474238c9cd6c9667771e8f"
  },
  {
    "url": "js/main.js",
    "revision": "9f6e65617cb7b7a67185b05427d97feb"
  },
  {
    "url": "js/app.min.js",
    "revision": "4f196ef1365d6ef38d2c681480ce618d"
  },
  {
    "url": "js/extensions.min.js",
    "revision": "65998885ad5af2f6a14315f3cd9e4d4c"
  },
  {
    "url": "js/orgchart.min.js",
    "revision": "619d8c4dab47b81868916df31f55478b"
  },
  {
    "url": "js/stencils.min.js",
    "revision": "5e2f2f82277b2cfc4c20b65da19bd1ca"
  },
  {
    "url": "js/shapes-14-6-5.min.js",
    "revision": "04c8d9b709f15514592b337ad33aad74"
  },
  {
    "url": "js/math-print.js",
    "revision": "cf64f6a493a8cb5079f2b70813e478d7"
  },
  {
    "url": "index.html",
    "revision": "9de11c65ec13b24c73ace7042bc529cc"
  },
  {
    "url": "styles/grapheditor.css",
    "revision": "23cbac10c03279392888893b3f694007"
  },
  {
    "url": "styles/high-contrast.css",
    "revision": "4ecc9f6d08787a9e2d29dacf7aadd1ca"
  },
  {
    "url": "js/dropbox/Dropbox-sdk.min.js",
    "revision": "4b9842892aa37b156db0a8364b7a83b0"
  },
  {
    "url": "js/onedrive/OneDrive.js",
    "revision": "505e8280346666f7ee801bc59521fa67"
  },
  {
    "url": "js/viewer-static.min.js",
    "revision": "86b7857f02304c6d7039d147014955ef"
  },
  {
    "url": "plugins/cConf-comments.js",
    "revision": "6deea8e9b96ff96043cd5cfd2a242a9f"
  },
  {
    "url": "plugins/cConf-1-4-8.js",
    "revision": "42137930327ac2a2500f711352b35e25"
  },
  {
    "url": "connect/confluence/connectUtils-1-4-8.js",
    "revision": "25c061e619a1bdbce765821594f0f79d"
  },
  {
    "url": "connect/new_common/cac.js",
    "revision": "740dce44cf53499f476ee8edc37d09a0"
  },
  {
    "url": "connect/gdrive_common/gac.js",
    "revision": "3bb38a5d9186a896ed04808e921ef888"
  },
  {
    "url": "connect/onedrive_common/ac.js",
    "revision": "5fb6ff1a73f54a9086b7a7e1f613b8ed"
  },
  {
    "url": "connect/confluence/viewer-init.js",
    "revision": "b82e366bf57ecced9435c2a8ba9cb9b9"
  },
  {
    "url": "connect/confluence/viewer.js",
    "revision": "fdb5a8e9f7cd3114a9f695348b93d207"
  },
  {
    "url": "connect/confluence/viewer-1-4-42.html",
    "revision": "69c1bca25fd4889bf832e8441c972268"
  },
  {
    "url": "connect/confluence/macroEditor-1-4-8.html",
    "revision": "4ad77ae3f08c19eddac932b2fa8c7068"
  },
  {
    "url": "connect/confluence/includeDiagram-1-4-8.js",
    "revision": "5b9f2e79efc7cadba0c06301edbeeff1"
  },
  {
    "url": "connect/confluence/includeDiagram.html",
    "revision": "01b04b3f54f1e2e63fcf1df033d24519"
  },
  {
    "url": "connect/confluence/macro-editor.js",
    "revision": "c4c110650228d22b021ebad4d6ef021e"
  },
  {
    "url": "resources/dia.txt",
    "revision": "66fe818e43b096f060797233ac192e69"
  },
  {
    "url": "mxgraph/css/common.css",
    "revision": "81d1704d5ab9207e2e5c7fc84379dc1a"
  }
], {
  "ignoreURLParametersMatching": [/.*/]
});








